import { createSidebarListItem } from "./createSidebarListItem";

export const generateSidebar = (articles) => {
  return `
    ${articles
      .map((item, index) => createSidebarListItem(item, index))
      .join("")}
  `;
};
